import { getGTMEventData } from '@tracking/components/transformer';

function feedbackFormFormatter({ ratingGiven, lengthOfInput }) {
  const eventName = 'end_feedback_submit';
  return getGTMEventData(eventName, eventName, {
    ratingGiven, lengthOfInput,
  }, ratingGiven, lengthOfInput);
}

export default feedbackFormFormatter;
